module.exports = __webpack_public_path__ + "static/apple-icon-152x152-e31ec614f85288b5ba93c31cc811ee41.png";